import { AddItemButton, ArrayInput, Button, required, SelectInput, SimpleForm, SimpleFormIterator } from "react-admin";
import { Grid } from "@mui/material";
import { settings } from "app";
import { ExamCommissionRoles } from "utils/choices";
import IndexField from "../IndexField";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import SaveButtonProfessors from "./SaveButtonProfessors";

export const groupByCommission = (professors = []) => {
  const map = {};

  professors.forEach(p => {
    const key = p.commissionNumber;

    if (!map[key]) {
      map[key] = {
        commissionNumber: key,
        professors: [],
      };
    }

    map[key].professors?.push({
      employeeId: p.employeeId,
      role: p.role,
    });
  });

  return Object.values(map).sort((a, b) => a.commissionNumber - b.commissionNumber);
};

const SetDefaultValues = ({ commissions }) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    setTimeout(() => {
      setValue("commissions", commissions, { shouldDirty: false });
    }, 0);
  }, []);

  return null;
};

const ProfessorsCommissionEditForm = ({ record, setIsProfessorEditing }) => {
  const professors = record?.commissions ?? [];
  const commissions = groupByCommission(professors);

  return (
    <Grid
      item
      xs={12}
    >
      <SimpleForm
        toolbar={false}
        sx={{ pt: 0, pl: 0 }}
      >
        <SetDefaultValues commissions={commissions} />
        <Grid
          container
          spacing={2}
        >
          <ArrayInput
            source="commissions"
            label=" "
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              addButton={<AddItemButton label="Добави комисия" />}
              inline={false}
              sx={settings.style.iteratorWithoutGap}
            >
              <IndexField />
              <ArrayInput
                source="professors"
                label=" "
                sx={{ ml: 2 }}
              >
                <SimpleFormIterator
                  disableReordering
                  disableClear
                  addButton={<AddItemButton label="Добави преподавател" />}
                  inline
                  sx={settings.style.iteratorWithoutGap}
                >
                  <ProfessorInput
                    source="employeeId"
                    fullWidth
                  />
                  <SelectInput
                    source="role"
                    label="Роля"
                    choices={ExamCommissionRoles}
                    validate={[required()]}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
        <Grid sx={{ display: "flex", gap: 3, ml: 2 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsProfessorEditing(false)}
          />
          <SaveButtonProfessors
            record={record}
            setIsProfessorEditing={setIsProfessorEditing}
          />
        </Grid>
      </SimpleForm>
    </Grid>
  );
};

export default ProfessorsCommissionEditForm;
